import api from './api'
import { logInfo, logError } from '../core/logger'
import cacheService from '../core/cache'

import API_URLS from '~/core/api-urls'

const RETRIES_COUNT = 5
const REQUEST_DELAY = 5000
const EXP_LEEWAY = 1000 * 60 * 60 * 2
const JITSI_TOKEN_RESPONSE = 'jitsi-token-response'

const delay = () => new Promise(resolve => {
  setTimeout(resolve, REQUEST_DELAY)
})

const isTokenValid = (tokenData) => tokenData && new Date(tokenData.exp * 1000 - EXP_LEEWAY) - new Date() > 0

const getTokenFromCache = () => new Promise(resolve =>
  cacheService.cache.get(JITSI_TOKEN_RESPONSE, data => resolve(data?.[JITSI_TOKEN_RESPONSE] || {}))
)

export const fetchToken = async () => {
  let attempt = 0
  const { result: tokenResp } = await getTokenFromCache()

  if (isTokenValid(tokenResp)) {
    return tokenResp
  }

  while (attempt < RETRIES_COUNT) {
    const result = await api.get(API_URLS.token)
    attempt += 1

    if (api.isErrorResponse(result)) {
      logError({ __filename, result }, 'Failed to retrieve Jitsi token.')
      if (attempt < RETRIES_COUNT) {
        logInfo({ __filename, result, attempt }, 'Retrying to retrieve Jitsi token.')
        await delay()
      }
    } else {
      await cacheService.cache.set({ [JITSI_TOKEN_RESPONSE]: { result } })
      logInfo({ __filename }, 'Retrieved Jitsi token.')

      return result
    }
  }

  throw new Error('Failed to retrieve Jitsi token after several attempts')
}

export default {}
